const API_BASE_URL = 'https://aca-manualmate-cc-prod-001.proudocean-fab4a47f.canadacentral.azurecontainerapps.io';

export const bookmarkService = {
  async fetchBookmarks(userId, tenantId) {
    const endpoint = `${API_BASE_URL}/bookmark`;
    const params = new URLSearchParams({
      user_id: userId,
      tenant_id: tenantId
    });

    console.log('Fetching bookmarks with params:', { userId, tenantId });
    console.log('Full URL:', `${endpoint}?${params}`);

    try {
      const response = await fetch(`${endpoint}?${params}`);

      if (response.ok) {
        const data = await response.json();
        console.log(`Successfully fetched ${data.data?.length || 0} bookmarks for user ${userId}`);
        return data;
      } else {
        const errorText = await response.text();
        console.error(`API request failed with status ${response.status}: ${errorText}`);
        return {
          success: false,
          errors: [`API request failed with status ${response.status}`],
          data: [],
          status_code: response.status
        };
      }
    } catch (error) {
      console.error('Error fetching bookmarks:', error);
      return {
        success: false,
        errors: [`Network error: ${error.message}`],
        data: [],
        status_code: 500
      };
    }
  },

  async deleteBookmark(queryId, userId, tenantId) {
    const url = `${API_BASE_URL}/deletebookmarks?user_id=${userId}&tenant_id=${tenantId}&query_id=${queryId}`;

    try {
      await fetch(url, { method: 'GET' });
    } catch (error) {
      console.error('Error deleting bookmark:', error);
    }
  }
};

export const urlUtils = {
  getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {
      userId: urlParams.get('user') || null,
      tenantId: urlParams.get('tenant') || null
    };
    console.log('URL Params extracted:', params);
    console.log('Current URL:', window.location.href);
    return params;
  },

  getUserAndTenantId(urlParams, teamsUserInfo) {
    const userId = urlParams.userId || 
                  (teamsUserInfo?.userId && teamsUserInfo.userId !== '' ? teamsUserInfo.userId : null) || 
                  'default_user';
    const tenantId = urlParams.tenantId || 
                    (teamsUserInfo?.tenantId && teamsUserInfo.tenantId !== '' ? teamsUserInfo.tenantId : null) || 
                    'default_tenant';
    
    console.log('Final user/tenant IDs:', { userId, tenantId });
    console.log('Source - URL params:', urlParams);
    console.log('Source - Teams context:', teamsUserInfo);
    
    return { userId, tenantId };
  }
};

export const textUtils = {
  extractUrlAndText(inputText) {
    if (!inputText) {
      return { url: null, formattedText: '' };
    }

    let url = null;
    let cleanedText = inputText;

    // First check for markdown-style links [text](url)
    const markdownUrlMatch = inputText.match(/\[.*?\]\((.*?)\)/);
    if (markdownUrlMatch) {
      url = markdownUrlMatch[1];
      cleanedText = inputText.replace(/\[.*?\]\(.*?\)/g, '').trim();
    } else {
      // If no markdown URL found, look for direct URLs (http/https)
      const directUrlMatch = cleanedText.match(/(https?:\/\/[^\s\)]+)/);
      if (directUrlMatch) {
        url = directUrlMatch[1];
        // Remove the URL from the text
        cleanedText = cleanedText.replace(/(https?:\/\/[^\s\)]+)/g, '').trim();
        // Clean up any remaining parentheses or brackets that might be left
        cleanedText = cleanedText.replace(/\(\s*\)/g, '').trim();
      }
    }

    const formattedText = this.convertMarkdownToHtml(cleanedText);

    return { url, formattedText };
  },

  convertMarkdownToHtml(text) {
    if (!text) return '';

    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');
    text = text.replace(/(?<!\*)\*([^*]+?)\*(?!\*)/g, '<em>$1</em>');
    text = text.replace(/(?<!_)_([^_]+?)_(?!_)/g, '<em>$1</em>');
    text = text.replace(/`([^`]+?)`/g, '<code>$1</code>');
    text = text.replace(/\n/g, '<br>');

    return text;
  },

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },

  formatBookmarksForUI(bookmarkData) {
    if (!bookmarkData.success) {
      return [];
    }

    const bookmarks = bookmarkData.data || [];
    const formattedBookmarks = [];

    for (const bookmark of bookmarks) {
      const responseText = bookmark.response || '';
      const { url, formattedText } = this.extractUrlAndText(responseText);

      const formattedBookmark = {
        id: bookmark.query_id || '',
        query_id: bookmark.query_id || '',
        query: bookmark.query || '',
        response: formattedText,
        is_bookmark: bookmark.is_bookmark !== undefined ? bookmark.is_bookmark : true,
        'Reference links': url || ''
      };

      formattedBookmarks.push(formattedBookmark);
    }

    return formattedBookmarks;
  }
};
